/*global ga*/
"use strict";

import $ from "jquery";
import gaCheck from "./util/ga_check";

$(document).on("turbolinks:load", function (e) {
  if (!gaCheck()) {
    return;
  }

  ga("set", "location", e.originalEvent.data.url);
  ga("send", "pageview");
});
